module.exports = __webpack_public_path__ + "static/media/top-brand-xiaomi-banner.3f5d35d2.png";